import React from 'react';
import { css } from '@emotion/react';
import pluralize from "pluralize";

import theme from "../../theme";
import { PromotionCode } from "../../config/graphQLTypes";

type Props = {
    billingStartDate: string,
    discountPriceByInterval: number | null,
    discountTotalPrice: string | null,
    numberOfUsers: string,
    period: string,
    planType: string,
    priceByInterval: number,
    promotionCode: PromotionCode | null,
    currencySymbol?: string,
    totalPrice: string,
};

const OrderSummarySubscription: React.FC<Props> = ({
    billingStartDate,
    discountPriceByInterval,
    discountTotalPrice,
    numberOfUsers,
    period,
    planType,
    priceByInterval,
    promotionCode,
    currencySymbol,
    totalPrice,
}) => {
    const isDiscounted = promotionCode !== null;

    return (
        <div css={containerStyle}>
            <div css={subscriptionStyle(isDiscounted)}>
                <div>{planType} Subscription</div>
                <div>{currencySymbol}{totalPrice}</div>
            </div>
            {isDiscounted && (
                <div css={subscriptionStyle(false)}>
                    <div>{promotionCode?.Coupon?.PercentOff}% off {promotionCode?.Coupon?.Term}</div>
                    <div>${discountTotalPrice}</div>
                </div>
            )}
            <div css={usersStyle}>
                <div css={numberOfUsersStyle}>{pluralize('User', parseInt(numberOfUsers), true)}</div>
                <div>{period}</div>
            </div>
            <div css={perUserStyle(isDiscounted)}>{currencySymbol}{priceByInterval.toFixed(2)} per user</div>
            {isDiscounted && (
                <div css={perUserStyle(false)}>{currencySymbol}{discountPriceByInterval?.toFixed(2)} per user</div>
            )}
            <div css={intervalStyle}>Starts next month: {billingStartDate}</div>
        </div>
    );
};

const containerStyle = css`
    padding: 21px 19px 21px 22px;
    font-weight: ${theme.fonts.weights.light};
`;

const subscriptionStyle = (isDiscounted: boolean) => css`
    min-height: 19px;
    line-height: 17px;
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    font-weight: ${theme.fonts.weights.base};

    ${isDiscounted && css`
        div:last-child {
            text-decoration: line-through;
        }
    `};
`;

const usersStyle = css`
    height: 19px;
    line-height: 17px;
    display: flex;
    justify-content: space-between;
`;

const numberOfUsersStyle = css`
    color: ${theme.colours.grey['650']};
`;

const perUserStyle = (isDiscounted: boolean) => css`
    height: 19px;
    line-height: 17px;
    color: ${theme.colours.grey['650']};

    ${isDiscounted && css`
        text-decoration: line-through;
    `};
`;

const intervalStyle = css`
    height: 19px;
    line-height: 17px;
    color: ${theme.colours.grey['650']};
    letter-spacing: -0.07px;
`;

export default OrderSummarySubscription;
